<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn @click="$router.push(`/products/${item.broadband_product_id}/`)" fab x-small color="secondary" v-bind="attrs" v-on="on">
        <v-icon>{{ mdiRouterWireless }}</v-icon>
      </v-btn>
    </template>
    <span>Waiting for broadband {{item.broadband_product_id}}</span>
  </v-tooltip>
</template>

<script>
  import { mdiRouterWireless } from '@mdi/js';

  export default {
    props: ['item'],

    data() {
      return {
        mdiRouterWireless,
      }
    },
  }
</script>

<style>

</style>
